import { Injectable } from '@angular/core'
import { map } from 'rxjs'

import { CONFIGURATION_KEYS } from '../model'
import { AuthenticatedRestService } from './auth-rest.service'
import { toData } from './rest'

@Injectable()
export class ConfigurationService {
  protected readonly route = '/configuration'
  constructor(
    protected readonly api: AuthenticatedRestService,
  ) {}

  public index(keys: string[]) {
    return this.api.get<Record<CONFIGURATION_KEYS, any>>(this.route, this.api.convertToParams({ keys }))
      .pipe(
        map(toData),
      )
  }

  public upsert(configurations: Record<string, any>) {
    return this.api.put(this.route, { configurations })
  }
}
